module.exports = __webpack_public_path__ + "img/image05.db4fec66.jpg";